import type { CategoryNames, ProvidersNames } from '@alien-platform/bo-core';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '..';

// Define the initial state for the currencies slice
interface GamesSliceState {
  categories: CategoryNames[] | null;
  providers: ProvidersNames[] | null;
}

const initialState: GamesSliceState = {
  categories: null,
  providers: null,
};

// Create the currencies slice
export const gamesSlice = createSlice({
  name: 'games',
  initialState,
  reducers: {
    // Reducer to add currencies to the state
    setGameCategories: (state, action: PayloadAction<CategoryNames[]>) => {
      state.categories = action.payload;
    },
    setGameProviders: (state, action: PayloadAction<ProvidersNames[]>) => {
      state.providers = action.payload;
    },
  },
});

// Export the action creators
export const { setGameCategories, setGameProviders } = gamesSlice.actions;

export const getGames = (state: RootState): GamesSliceState => state.games;
